export const teamTranslations = {
  en: {
    title: 'Leadership',
    subtitle: 'Scientific Expertise Meets Practical Implementation.',
    teamMembers: [
      // {
      //   id: 1,
      //   name: 'Lucas',
      //   role: 'AI Engineering & Implementation',
      //   description: "Lucas specializes in the technical implementation of text analysis solutions for companies. With his expertise in GPT-4, Claude, and modern LLM architectures, he develops customized NLP pipelines and cloud solutions. His strength lies in translating cutting-edge AI technologies into working business solutions.",
      //   image: 'lucas.jpg'
      // },
      {
        id: 2,
        name: 'Fiarra',
        role: 'AI Research & Text Data Science',
        description: "Fiarra brings deep scientific expertise in text analysis. As a PhD candidate in Computational Social Sciences focusing on Large Language Models, she develops data-driven solutions for document processing and text classification. She combines academic precision with practical implementation for enterprise clients.",
        image: 'fiarra.jpg'
      }
    ]
  },
  de: {
    title: 'Leitung',
    subtitle: 'Wissenschaftliche Expertise trifft auf praktische Umsetzung.',
    teamMembers: [
      // {
      //   id: 1,
      //   name: 'Lucas',
      //   role: 'KI-Engineering & Implementierung',
      //   description: "Lucas spezialisiert sich auf die technische Umsetzung von Textanalyse-Lösungen für Unternehmen. Mit seiner Expertise in GPT-4, Claude und modernen LLM-Architekturen entwickelt er maßgeschneiderte NLP-Pipelines und Cloud-Lösungen. Seine Stärke liegt in der Überführung modernster KI-Technologien in funktionierende Geschäftslösungen.",
      //   image: 'lucas.jpg'
      // },
      {
        id: 2,
        name: 'Fiarra',
        role: 'KI-Forschung & Textdaten-Wissenschaft',
        description: "Fiarra bringt tiefgreifende wissenschaftliche Expertise in der Textanalyse mit. Als Doktorandin der Computational Social Sciences mit Fokus auf Large Language Models entwickelt sie datengetriebene Lösungen für Dokumentenverarbeitung und Textklassifikation. Sie verbindet akademische Präzision mit praxisorientierter Umsetzung für Unternehmenskunden.",
        image: 'fiarra.jpg'
      }
    ]
  }
}; 